import { useState } from "react";
import type { SessionPlan } from "../data/schema";
import { DrillCard } from "./DrillCard";
import { Button, Screen } from "./ui";

export function SessionView({
  plan,
  profileName,
  onSwap,
  onFinish,
  onExit,
}: {
  plan: SessionPlan;
  profileName: string;
  onSwap: (index: number) => void;
  onFinish: (doneDrillIds: string[]) => void;
  onExit: () => void;
}) {
  const [done, setDone] = useState<Set<string>>(new Set());
  const total = plan.drills.reduce((s, d) => s + d.allocatedMin, 0);

  const toggle = (id: string) =>
    setDone((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  return (
    <Screen
      title={`${profileName}'s session`}
      right={
        <button onClick={onExit} className="text-lg font-semibold text-[var(--color-pitch)]">
          Exit
        </button>
      }
    >
      <p className="mb-4 text-lg text-neutral-600">
        {plan.drills.length} drills · about {total} min · {done.size} done
      </p>

      <div className="space-y-3">
        {plan.drills.map((pd, i) => (
          <DrillCard
            key={`${pd.drill.id}-${i}`}
            pd={pd}
            index={i}
            done={done.has(pd.drill.id)}
            onToggleDone={() => toggle(pd.drill.id)}
            onSwap={() => onSwap(i)}
          />
        ))}
      </div>

      <Button className="mt-6 w-full" onClick={() => onFinish([...done])}>
        Finish &amp; log session
      </Button>
    </Screen>
  );
}
